import React from 'react';
import { useSelector } from 'react-redux';

import Main from 'pages/Layout/Main';
import UserDefinitionsView from 'pages/Modules/Definitions/UserDefinitionsView';
import { hasPermission } from 'utils/helper';
import { permissions } from 'constant/permissions';
import { roleSettingsSelector } from 'redux/slices/app/authSlice';
import Landing from 'pages/Modules/Landing/Landing';

const UserDefinitions = () => {
  const roleSettingsInfo = useSelector(roleSettingsSelector);

  return (
    <Main>
      {hasPermission(permissions.userDefinition, 'VIEW', roleSettingsInfo) ? (
        <UserDefinitionsView />
      ) : (
        <Landing />
      )}
    </Main>
  );
};

export default UserDefinitions;
